import { default as FacebookLoginF1fZ8470EUMeta } from "/home/node/app/pages/FacebookLogin.vue?macro=true";
import { default as indexQTt3rwlqVjMeta } from "/home/node/app/pages/buy/[perform]/[poster]/index.vue?macro=true";
import { default as _91id_93Ivjtiqm2O7Meta } from "/home/node/app/pages/compilation/[id].vue?macro=true";
import { default as contacts6vbY1ptpMJMeta } from "/home/node/app/pages/contacts.vue?macro=true";
import { default as _91slug_93QO5s7XnQPDMeta } from "/home/node/app/pages/documents/[slug].vue?macro=true";
import { default as indexZVNuZdNpkZMeta } from "/home/node/app/pages/documents/index.vue?macro=true";
import { default as indexca63Ho8mnZMeta } from "/home/node/app/pages/index.vue?macro=true";
import { default as loginNK2g5GJ8AIMeta } from "/home/node/app/pages/login.vue?macro=true";
import { default as indexjFlVTBZO7VMeta } from "/home/node/app/pages/media/index.vue?macro=true";
import { default as _91id_93AbZaQlT8n5Meta } from "/home/node/app/pages/media/photos/[id].vue?macro=true";
import { default as indexgOcZs5ruPYMeta } from "/home/node/app/pages/media/photos/index.vue?macro=true";
import { default as presse2sSoAFErYMeta } from "/home/node/app/pages/media/press.vue?macro=true";
import { default as _91id_93ZSkxecSvBuMeta } from "/home/node/app/pages/media/videos/[id].vue?macro=true";
import { default as indexi7bC7h5lTRMeta } from "/home/node/app/pages/media/videos/index.vue?macro=true";
import { default as _91id_93Olnytllka0Meta } from "/home/node/app/pages/news/[id].vue?macro=true";
import { default as indexv6fQ1hORb0Meta } from "/home/node/app/pages/news/index.vue?macro=true";
import { default as indexNifgamdnRlMeta } from "/home/node/app/pages/posters/index.vue?macro=true";
import { default as recovery_45accountFiDjGojwfoMeta } from "/home/node/app/pages/recovery-account.vue?macro=true";
import { default as _91id_93kc7dAjIMdRMeta } from "/home/node/app/pages/recovery/[id].vue?macro=true";
import { default as _91id_935UBMKk0meaMeta } from "/home/node/app/pages/theater/halls/[id].vue?macro=true";
import { default as indexTmDR1N8HEBMeta } from "/home/node/app/pages/theater/halls/index.vue?macro=true";
import { default as index1jYoiCDx53Meta } from "/home/node/app/pages/theater/index.vue?macro=true";
import { default as _91id_930EWrvTKsPjMeta } from "/home/node/app/pages/theater/performs/[id].vue?macro=true";
import { default as indexgiMYgyLobOMeta } from "/home/node/app/pages/theater/performs/index.vue?macro=true";
import { default as _91id_93dnErdOIotYMeta } from "/home/node/app/pages/theater/staff/[id].vue?macro=true";
import { default as indexkYGVH3T4FfMeta } from "/home/node/app/pages/theater/staff/index.vue?macro=true";
import { default as _91id_93C6lwPo5tWgMeta } from "/home/node/app/pages/theater/troupe/[id].vue?macro=true";
import { default as indexlo3hPNLL2IMeta } from "/home/node/app/pages/theater/troupe/index.vue?macro=true";
import { default as _91id_932nf6738yLoMeta } from "/home/node/app/pages/theater/voutings/[id].vue?macro=true";
import { default as indexfO07wvqTBmMeta } from "/home/node/app/pages/theater/voutings/index.vue?macro=true";
import { default as _91id_93je8dqtqWYwMeta } from "/home/node/app/pages/tickets/[id].vue?macro=true";
import { default as facebookLkoY81nhI5Meta } from "/home/node/app/pages/user/facebook.vue?macro=true";
import { default as indexfd5eUGy1VaMeta } from "/home/node/app/pages/user/index.vue?macro=true";
import { default as _91id_93eBsQ5HoyOAMeta } from "/home/node/app/pages/user/orders/[id].vue?macro=true";
import { default as _91id_93Aw52t5dezDMeta } from "/home/node/app/pages/verify/[id].vue?macro=true";
export default [
  {
    name: FacebookLoginF1fZ8470EUMeta?.name ?? "FacebookLogin",
    path: FacebookLoginF1fZ8470EUMeta?.path ?? "/FacebookLogin",
    children: [],
    meta: FacebookLoginF1fZ8470EUMeta,
    alias: FacebookLoginF1fZ8470EUMeta?.alias || [],
    redirect: FacebookLoginF1fZ8470EUMeta?.redirect || undefined,
    component: () => import("/home/node/app/pages/FacebookLogin.vue").then(m => m.default || m)
  },
  {
    name: indexQTt3rwlqVjMeta?.name ?? "buy-perform-poster",
    path: indexQTt3rwlqVjMeta?.path ?? "/buy/:perform/:poster",
    children: [],
    meta: indexQTt3rwlqVjMeta,
    alias: indexQTt3rwlqVjMeta?.alias || [],
    redirect: indexQTt3rwlqVjMeta?.redirect || undefined,
    component: () => import("/home/node/app/pages/buy/[perform]/[poster]/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93Ivjtiqm2O7Meta?.name ?? "compilation-id",
    path: _91id_93Ivjtiqm2O7Meta?.path ?? "/compilation/:id",
    children: [],
    meta: _91id_93Ivjtiqm2O7Meta,
    alias: _91id_93Ivjtiqm2O7Meta?.alias || [],
    redirect: _91id_93Ivjtiqm2O7Meta?.redirect || undefined,
    component: () => import("/home/node/app/pages/compilation/[id].vue").then(m => m.default || m)
  },
  {
    name: contacts6vbY1ptpMJMeta?.name ?? "contacts",
    path: contacts6vbY1ptpMJMeta?.path ?? "/contacts",
    children: [],
    meta: contacts6vbY1ptpMJMeta,
    alias: contacts6vbY1ptpMJMeta?.alias || [],
    redirect: contacts6vbY1ptpMJMeta?.redirect || undefined,
    component: () => import("/home/node/app/pages/contacts.vue").then(m => m.default || m)
  },
  {
    name: _91slug_93QO5s7XnQPDMeta?.name ?? "documents-slug",
    path: _91slug_93QO5s7XnQPDMeta?.path ?? "/documents/:slug",
    children: [],
    meta: _91slug_93QO5s7XnQPDMeta,
    alias: _91slug_93QO5s7XnQPDMeta?.alias || [],
    redirect: _91slug_93QO5s7XnQPDMeta?.redirect || undefined,
    component: () => import("/home/node/app/pages/documents/[slug].vue").then(m => m.default || m)
  },
  {
    name: indexZVNuZdNpkZMeta?.name ?? "documents",
    path: indexZVNuZdNpkZMeta?.path ?? "/documents",
    children: [],
    meta: indexZVNuZdNpkZMeta,
    alias: indexZVNuZdNpkZMeta?.alias || [],
    redirect: indexZVNuZdNpkZMeta?.redirect || undefined,
    component: () => import("/home/node/app/pages/documents/index.vue").then(m => m.default || m)
  },
  {
    name: indexca63Ho8mnZMeta?.name ?? "index",
    path: indexca63Ho8mnZMeta?.path ?? "/",
    children: [],
    meta: indexca63Ho8mnZMeta,
    alias: indexca63Ho8mnZMeta?.alias || [],
    redirect: indexca63Ho8mnZMeta?.redirect || undefined,
    component: () => import("/home/node/app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: loginNK2g5GJ8AIMeta?.name ?? "login",
    path: loginNK2g5GJ8AIMeta?.path ?? "/login",
    children: [],
    meta: loginNK2g5GJ8AIMeta,
    alias: loginNK2g5GJ8AIMeta?.alias || [],
    redirect: loginNK2g5GJ8AIMeta?.redirect || undefined,
    component: () => import("/home/node/app/pages/login.vue").then(m => m.default || m)
  },
  {
    name: indexjFlVTBZO7VMeta?.name ?? "media",
    path: indexjFlVTBZO7VMeta?.path ?? "/media",
    children: [],
    meta: indexjFlVTBZO7VMeta,
    alias: indexjFlVTBZO7VMeta?.alias || [],
    redirect: indexjFlVTBZO7VMeta?.redirect || undefined,
    component: () => import("/home/node/app/pages/media/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93AbZaQlT8n5Meta?.name ?? "media-photos-id",
    path: _91id_93AbZaQlT8n5Meta?.path ?? "/media/photos/:id",
    children: [],
    meta: _91id_93AbZaQlT8n5Meta,
    alias: _91id_93AbZaQlT8n5Meta?.alias || [],
    redirect: _91id_93AbZaQlT8n5Meta?.redirect || undefined,
    component: () => import("/home/node/app/pages/media/photos/[id].vue").then(m => m.default || m)
  },
  {
    name: indexgOcZs5ruPYMeta?.name ?? "media-photos",
    path: indexgOcZs5ruPYMeta?.path ?? "/media/photos",
    children: [],
    meta: indexgOcZs5ruPYMeta,
    alias: indexgOcZs5ruPYMeta?.alias || [],
    redirect: indexgOcZs5ruPYMeta?.redirect || undefined,
    component: () => import("/home/node/app/pages/media/photos/index.vue").then(m => m.default || m)
  },
  {
    name: presse2sSoAFErYMeta?.name ?? "media-press",
    path: presse2sSoAFErYMeta?.path ?? "/media/press",
    children: [],
    meta: presse2sSoAFErYMeta,
    alias: presse2sSoAFErYMeta?.alias || [],
    redirect: presse2sSoAFErYMeta?.redirect || undefined,
    component: () => import("/home/node/app/pages/media/press.vue").then(m => m.default || m)
  },
  {
    name: _91id_93ZSkxecSvBuMeta?.name ?? "media-videos-id",
    path: _91id_93ZSkxecSvBuMeta?.path ?? "/media/videos/:id",
    children: [],
    meta: _91id_93ZSkxecSvBuMeta,
    alias: _91id_93ZSkxecSvBuMeta?.alias || [],
    redirect: _91id_93ZSkxecSvBuMeta?.redirect || undefined,
    component: () => import("/home/node/app/pages/media/videos/[id].vue").then(m => m.default || m)
  },
  {
    name: indexi7bC7h5lTRMeta?.name ?? "media-videos",
    path: indexi7bC7h5lTRMeta?.path ?? "/media/videos",
    children: [],
    meta: indexi7bC7h5lTRMeta,
    alias: indexi7bC7h5lTRMeta?.alias || [],
    redirect: indexi7bC7h5lTRMeta?.redirect || undefined,
    component: () => import("/home/node/app/pages/media/videos/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93Olnytllka0Meta?.name ?? "news-id",
    path: _91id_93Olnytllka0Meta?.path ?? "/news/:id",
    children: [],
    meta: _91id_93Olnytllka0Meta,
    alias: _91id_93Olnytllka0Meta?.alias || [],
    redirect: _91id_93Olnytllka0Meta?.redirect || undefined,
    component: () => import("/home/node/app/pages/news/[id].vue").then(m => m.default || m)
  },
  {
    name: indexv6fQ1hORb0Meta?.name ?? "news",
    path: indexv6fQ1hORb0Meta?.path ?? "/news",
    children: [],
    meta: indexv6fQ1hORb0Meta,
    alias: indexv6fQ1hORb0Meta?.alias || [],
    redirect: indexv6fQ1hORb0Meta?.redirect || undefined,
    component: () => import("/home/node/app/pages/news/index.vue").then(m => m.default || m)
  },
  {
    name: indexNifgamdnRlMeta?.name ?? "posters",
    path: indexNifgamdnRlMeta?.path ?? "/posters",
    children: [],
    meta: indexNifgamdnRlMeta,
    alias: indexNifgamdnRlMeta?.alias || [],
    redirect: indexNifgamdnRlMeta?.redirect || undefined,
    component: () => import("/home/node/app/pages/posters/index.vue").then(m => m.default || m)
  },
  {
    name: recovery_45accountFiDjGojwfoMeta?.name ?? "recovery-account",
    path: recovery_45accountFiDjGojwfoMeta?.path ?? "/recovery-account",
    children: [],
    meta: recovery_45accountFiDjGojwfoMeta,
    alias: recovery_45accountFiDjGojwfoMeta?.alias || [],
    redirect: recovery_45accountFiDjGojwfoMeta?.redirect || undefined,
    component: () => import("/home/node/app/pages/recovery-account.vue").then(m => m.default || m)
  },
  {
    name: _91id_93kc7dAjIMdRMeta?.name ?? "recovery-id",
    path: _91id_93kc7dAjIMdRMeta?.path ?? "/recovery/:id",
    children: [],
    meta: _91id_93kc7dAjIMdRMeta,
    alias: _91id_93kc7dAjIMdRMeta?.alias || [],
    redirect: _91id_93kc7dAjIMdRMeta?.redirect || undefined,
    component: () => import("/home/node/app/pages/recovery/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_935UBMKk0meaMeta?.name ?? "theater-halls-id",
    path: _91id_935UBMKk0meaMeta?.path ?? "/theater/halls/:id",
    children: [],
    meta: _91id_935UBMKk0meaMeta,
    alias: _91id_935UBMKk0meaMeta?.alias || [],
    redirect: _91id_935UBMKk0meaMeta?.redirect || undefined,
    component: () => import("/home/node/app/pages/theater/halls/[id].vue").then(m => m.default || m)
  },
  {
    name: indexTmDR1N8HEBMeta?.name ?? "theater-halls",
    path: indexTmDR1N8HEBMeta?.path ?? "/theater/halls",
    children: [],
    meta: indexTmDR1N8HEBMeta,
    alias: indexTmDR1N8HEBMeta?.alias || [],
    redirect: indexTmDR1N8HEBMeta?.redirect || undefined,
    component: () => import("/home/node/app/pages/theater/halls/index.vue").then(m => m.default || m)
  },
  {
    name: index1jYoiCDx53Meta?.name ?? "theater",
    path: index1jYoiCDx53Meta?.path ?? "/theater",
    children: [],
    meta: index1jYoiCDx53Meta,
    alias: index1jYoiCDx53Meta?.alias || [],
    redirect: index1jYoiCDx53Meta?.redirect || undefined,
    component: () => import("/home/node/app/pages/theater/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_930EWrvTKsPjMeta?.name ?? "theater-performs-id",
    path: _91id_930EWrvTKsPjMeta?.path ?? "/theater/performs/:id",
    children: [],
    meta: _91id_930EWrvTKsPjMeta,
    alias: _91id_930EWrvTKsPjMeta?.alias || [],
    redirect: _91id_930EWrvTKsPjMeta?.redirect || undefined,
    component: () => import("/home/node/app/pages/theater/performs/[id].vue").then(m => m.default || m)
  },
  {
    name: indexgiMYgyLobOMeta?.name ?? "theater-performs",
    path: indexgiMYgyLobOMeta?.path ?? "/theater/performs",
    children: [],
    meta: indexgiMYgyLobOMeta,
    alias: indexgiMYgyLobOMeta?.alias || [],
    redirect: indexgiMYgyLobOMeta?.redirect || undefined,
    component: () => import("/home/node/app/pages/theater/performs/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93dnErdOIotYMeta?.name ?? "theater-staff-id",
    path: _91id_93dnErdOIotYMeta?.path ?? "/theater/staff/:id",
    children: [],
    meta: _91id_93dnErdOIotYMeta,
    alias: _91id_93dnErdOIotYMeta?.alias || [],
    redirect: _91id_93dnErdOIotYMeta?.redirect || undefined,
    component: () => import("/home/node/app/pages/theater/staff/[id].vue").then(m => m.default || m)
  },
  {
    name: indexkYGVH3T4FfMeta?.name ?? "theater-staff",
    path: indexkYGVH3T4FfMeta?.path ?? "/theater/staff",
    children: [],
    meta: indexkYGVH3T4FfMeta,
    alias: indexkYGVH3T4FfMeta?.alias || [],
    redirect: indexkYGVH3T4FfMeta?.redirect || undefined,
    component: () => import("/home/node/app/pages/theater/staff/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93C6lwPo5tWgMeta?.name ?? "theater-troupe-id",
    path: _91id_93C6lwPo5tWgMeta?.path ?? "/theater/troupe/:id",
    children: [],
    meta: _91id_93C6lwPo5tWgMeta,
    alias: _91id_93C6lwPo5tWgMeta?.alias || [],
    redirect: _91id_93C6lwPo5tWgMeta?.redirect || undefined,
    component: () => import("/home/node/app/pages/theater/troupe/[id].vue").then(m => m.default || m)
  },
  {
    name: indexlo3hPNLL2IMeta?.name ?? "theater-troupe",
    path: indexlo3hPNLL2IMeta?.path ?? "/theater/troupe",
    children: [],
    meta: indexlo3hPNLL2IMeta,
    alias: indexlo3hPNLL2IMeta?.alias || [],
    redirect: indexlo3hPNLL2IMeta?.redirect || undefined,
    component: () => import("/home/node/app/pages/theater/troupe/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_932nf6738yLoMeta?.name ?? "theater-voutings-id",
    path: _91id_932nf6738yLoMeta?.path ?? "/theater/voutings/:id",
    children: [],
    meta: _91id_932nf6738yLoMeta,
    alias: _91id_932nf6738yLoMeta?.alias || [],
    redirect: _91id_932nf6738yLoMeta?.redirect || undefined,
    component: () => import("/home/node/app/pages/theater/voutings/[id].vue").then(m => m.default || m)
  },
  {
    name: indexfO07wvqTBmMeta?.name ?? "theater-voutings",
    path: indexfO07wvqTBmMeta?.path ?? "/theater/voutings",
    children: [],
    meta: indexfO07wvqTBmMeta,
    alias: indexfO07wvqTBmMeta?.alias || [],
    redirect: indexfO07wvqTBmMeta?.redirect || undefined,
    component: () => import("/home/node/app/pages/theater/voutings/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93je8dqtqWYwMeta?.name ?? "tickets-id",
    path: _91id_93je8dqtqWYwMeta?.path ?? "/tickets/:id",
    children: [],
    meta: _91id_93je8dqtqWYwMeta,
    alias: _91id_93je8dqtqWYwMeta?.alias || [],
    redirect: _91id_93je8dqtqWYwMeta?.redirect || undefined,
    component: () => import("/home/node/app/pages/tickets/[id].vue").then(m => m.default || m)
  },
  {
    name: facebookLkoY81nhI5Meta?.name ?? "user-facebook",
    path: facebookLkoY81nhI5Meta?.path ?? "/user/facebook",
    children: [],
    meta: facebookLkoY81nhI5Meta,
    alias: facebookLkoY81nhI5Meta?.alias || [],
    redirect: facebookLkoY81nhI5Meta?.redirect || undefined,
    component: () => import("/home/node/app/pages/user/facebook.vue").then(m => m.default || m)
  },
  {
    name: indexfd5eUGy1VaMeta?.name ?? "user",
    path: indexfd5eUGy1VaMeta?.path ?? "/user",
    children: [],
    meta: indexfd5eUGy1VaMeta,
    alias: indexfd5eUGy1VaMeta?.alias || [],
    redirect: indexfd5eUGy1VaMeta?.redirect || undefined,
    component: () => import("/home/node/app/pages/user/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93eBsQ5HoyOAMeta?.name ?? "user-orders-id",
    path: _91id_93eBsQ5HoyOAMeta?.path ?? "/user/orders/:id",
    children: [],
    meta: _91id_93eBsQ5HoyOAMeta,
    alias: _91id_93eBsQ5HoyOAMeta?.alias || [],
    redirect: _91id_93eBsQ5HoyOAMeta?.redirect || undefined,
    component: () => import("/home/node/app/pages/user/orders/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_93Aw52t5dezDMeta?.name ?? "verify-id",
    path: _91id_93Aw52t5dezDMeta?.path ?? "/verify/:id",
    children: [],
    meta: _91id_93Aw52t5dezDMeta,
    alias: _91id_93Aw52t5dezDMeta?.alias || [],
    redirect: _91id_93Aw52t5dezDMeta?.redirect || undefined,
    component: () => import("/home/node/app/pages/verify/[id].vue").then(m => m.default || m)
  }
]